import UserCompositionChart from './UserCompositionChart';

export default UserCompositionChart;
